(() => {
  const OFFSET = 84;
  const SELECTOR = [
    '#ShopifyChat', '#shopify-chat', 'shopify-chat', '#shopify-chat-dummy',
    '[id*="shopify-chat" i]', '[id*="shopify_chat" i]', '[class*="shopify-chat" i]',
    'iframe[title*="Shopify Inbox" i]', 'iframe[title*="chat" i]',
    '[id*="dondy" i]', '[class*="dondy" i]',
    '[id*="whatsapp" i]', '[class*="whatsapp" i]',
    'iframe[src*="whatsapp" i]', 'iframe[title*="whatsapp" i]'
  ].join(',');

  function fixedRoot(element) {
    let node = element;
    while (node && node !== document.body) {
      const position = getComputedStyle(node).position;
      if (position === 'fixed') return node;
      node = node.parentElement;
    }
    return null;
  }

  function raiseWidgets() {
    if (!document.documentElement.hasAttribute('data-pb-product-page')) return;
    if (!matchMedia('(max-width: 749px)').matches) return;

    document.querySelectorAll(SELECTOR).forEach((candidate) => {
      const root = fixedRoot(candidate);
      if (!root || root.dataset.pbMobileRaised === 'true') return;

      const currentBottom = parseFloat(getComputedStyle(root).bottom);
      if (!Number.isFinite(currentBottom)) return;

      root.style.setProperty('bottom', `${currentBottom + OFFSET}px`, 'important');
      root.dataset.pbMobileRaised = 'true';
    });
  }

  const observer = new MutationObserver(raiseWidgets);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', raiseWidgets);
  window.addEventListener('resize', raiseWidgets);
  raiseWidgets();
})();
